/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Job } from "./Job";
export const JobResponse = core.serialization.object({
    data: Job,
});
